import React from "react";
import "../styles/Global.css";
interface ButtonProps {
  onClick: () => void;
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  className,
  children,
  style,
  disabled = false,
}) => {
  // Combine the base 'button' class with any additional classes
  const buttonClasses = className ? `button ${className}` : "button";

  return (
    <button
      className={buttonClasses}
      onClick={disabled ? undefined : onClick}
      style={style}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
